import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { createPullRequest } from '@/services/git/api';
import type { CreatePullRequestInput, GitPullRequestDetail } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useCreatePullRequest(): UseMutationResult<GitPullRequestDetail, Error, CreatePullRequestInput> {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useMutation({
    mutationFn: (input: CreatePullRequestInput) => createPullRequest(orgId!, input),
    meta: { silent: true },
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['gitPullRequests', orgId, vars.repo_full_name] });
    },
  });
}
